import React from "react";
import styles from "./contact.module.scss";
import { contactIcon } from "../../utils/svg";
import ContactImg from "@assets/images/contact.jpg";
import { TechCard } from "../../components/tech-card/TechCard.component";
import { ContactForm } from "../../components/contact-form/ContactForm.component";
import { ScrollReveal } from "../../components/scroll-reveal/ScrollReveal.component";
import { LazyImage } from "../../components/lazy-image/LazyImage.component";
import { SeoComponent } from "../../components/seo/Seo.component";

export const Contact: React.FC = () => {
  const GetInTouch: React.FC = () => {
    return (
      <div className={styles["content-wrapper"]}>
        <SeoComponent
          title="Contact Us | Volumetric"
          description="Get in touch with Volumetric. We are always excited to connect with new partners and discuss innovative ideas."
        />
        <div className={styles["column"]}>
          <p>
            We are always excited to connect with new partners, discuss
            innovative ideas, or explore potential collaborations. Whether you
            have a question, want to chat about a project, or just want to say
            hello, we'd love to hear from you!
          </p>
          <ContactForm />
        </div>
        <div className={styles["image-wrapper"]}>
          <LazyImage
            className={styles["image"]}
            src={ContactImg}
            alt="Contact"
          />
        </div>
      </div>
    );
  };

  return (
    <div className={styles["contact"]}>
      <ScrollReveal animation="fade-up">
        <TechCard
          title="Get In Touch"
          icon={contactIcon}
          iconViewBox="0 0 512 512">
          <GetInTouch />
        </TechCard>
      </ScrollReveal>
    </div>
  );
};
